import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=39d2ece9&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=ts&"
export * from "./notice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d2ece9",
  null
  
)

export default component.exports